export default {
  computed: {
    // Calculate default page
    gridPage () {
      return this.$route.query.page || 1
    },

    // Calculate default pageSize
    gridPageSize () {
      const lsPageSize = localStorage.getItem(`gridPageSize-${this.$store.getters.authenticatedUser.login}`)
      const savedPageSize = lsPageSize ? Number(lsPageSize) : null
      const queryPageSize = this.$route.query.pageSize ? Number(this.$route.query.pageSize) : null

      return queryPageSize || savedPageSize || 10
    },

    // Compute the two previous params
    queryPageParams () {
      return { page: this.gridPage, pageSize: this.gridPageSize }
    }
  }
}
